const DITypes = {
  JsonRpcDispatcher: Symbol('CondorJsonRpcDispatcher'),
  DispatcherFactory: Symbol('CondorDispatcherFactory'),
  AdapterFactory: Symbol('CondorAdapterFactory'),
};

export default DITypes;
